import PaigeReview from "./PaigeReview";

export default PaigeReview;
